var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_66",
    "data-name": "Group 66",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#24262b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_1_",
    "data-name": "close (1)",
    d: "M6.2,4.661,9.083,1.777a.815.815,0,0,0,0-1.153L8.7.239a.815.815,0,0,0-1.153,0L4.662,3.123,1.778.239a.815.815,0,0,0-1.153,0L.239.623a.815.815,0,0,0,0,1.153L3.124,4.661.24,7.545A.815.815,0,0,0,.24,8.7l.384.384a.815.815,0,0,0,1.153,0L4.662,6.2,7.545,9.083a.815.815,0,0,0,1.153,0L9.083,8.7a.815.815,0,0,0,0-1.153Zm0,0",
    transform: "translate(5.183 5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSvg);
export default __webpack_public_path__ + "static/media/cancel_svg.3f48654acbc5bad975f85be1cbf463ee.svg";
export { ForwardRef as ReactComponent };